import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
];

function Privacy() {
  return (
    <div className="substack-site">
      <Header navItems={NAV_ITEMS} />

      <main className="legal-page">
        <div className="legal-container">
          <h1>Privacy Policy</h1>
          
          <p className="intro-text">
            Our privacy policy is pretty straight forward. We respect your privacy. We won't sell or rent your personal information to anyone for any reason. If you opt to join our email newsletter, we will only send you information related to the OBX Beach Bum products and services and you can unsubscribe anytime.
          </p>
          
          <p>
            The OBX Beach Bum knows that you may have concerns about your privacy while shopping or just bumming around on the Internet. This Privacy Policy describes how we use and do not use the information provided to us at theobxbeachbum.com, and the steps we take to protect it. This Privacy Policy only applies to information collected online.
          </p>

          <section>
            <h2>Personal Information We Collect Online</h2>
            <p>
              When you make a purchase on theobxbeachbum.com, we ask for your name, address, phone number, email address and other personal information necessary to fulfill and track your order. For purposes of billing, you will need to provide your credit card type, number, expiration date and billing address for the card. If your order is to be shipped, we also need the name, address and phone number of the intended recipient(s).
            </p>
            <p>
              You also may create an account through theobxbeachbum.com at any time by providing your email address and designating a unique access password. You do not need to create an account to visit our site but you will need an account to place an order through theobxbeachbum.com. Creating an account allows you to save certain billing information so that you can set your ordering preferences. For your privacy and security, we do not store credit card numbers in your account.
            </p>
          </section>

          <section>
            <h2>Cookies</h2>
            <p>
              The OBX Beach Bum uses session cookies to observe your navigation throughout the website for the purposes described above. You may set your Web browser to notify you when you receive a cookie and you may also erase cookies from your browser after shopping. If you delete our cookies, you limit our ability to personalize theobxbeachbum.com for your next shopping visit; however, deleting a cookie will not prevent you from shopping and purchasing at our site in the future.
            </p>
          </section>

          <section>
            <h2>Is Information Shared with Third Parties?</h2>
            <p>
              We do not rent, sell or exchange your name or other personally-identifiable information to third-party companies for their marketing purposes. We do provide your personal information to reputable organizations that help us to fulfill your order. For example, we use companies to verify and process credit card transactions and to deliver packages. We may be required to disclose your personal information to third parties if necessary to comply with applicable laws, subpoenas or court orders.
            </p>
          </section>

          <section>
            <h2>How Will My Information Be Used?</h2>
            <p>Information collected on theobxbeachbum.com may be used in the following ways:</p>
            <ul>
              <li>Schedule deliveries of merchandise that you purchase online</li>
              <li>Create an online account for you at theobxbeachbum.com</li>
              <li>Bill your credit card for your purchases</li>
              <li>Confirm and track your orders</li>
              <li>Respond to your customer service inquiries</li>
              <li>Provide promotional communication and other information to you, if you choose to receive them</li>
              <li>Offer the products you want</li>
              <li>Customize your shopping experience</li>
              <li>Improve our website design</li>
            </ul>
          </section>

          <section>
            <h2>Accessing and Updating My Information</h2>
            <p>
              You can access and correct information you have shared with us online if you have established an account with theobxbeachbum.com. Do not share your theobxbeachbum.com password with anyone.
            </p>
          </section>

          <section>
            <h2>How Can I Decide What Promotional Communications I Will Receive?</h2>
            <p>
              The personal information you supply us will be added to our customer database. We may send you promotional emails about the OBX Beach Bum products and events which we hope will be of interest.
            </p>
          </section>

          <section>
            <h2>Children's Online Policy</h2>
            <p>
              The OBX Beach Bum is committed to preserving online privacy for all of its website visitors, including children. theobxbeachbum.com is a general audience site, and we do not knowingly collect information about children or sell products to children. Consistent with the Children's Online Privacy Protection Act, we will not knowingly collect any information from or sell products to children under the age of 13. If you are under the age of 13, you must ask your parent or guardian to assist you in using theobxbeachbum.com.
            </p>
          </section>

          <section>
            <h2>Linking to and from Outside Websites</h2>
            <p>
              theobxbeachbum.com sometimes provides links to other companies' websites. Unless we expressly say otherwise, a link to another website does not mean that we are responsible for, or that we endorse the content or policy of that website. When you provide information at one of those sites, you are subject to that site's privacy policy. We encourage you to read that website's policy before submitting any information if you have concerns about how information may be collected or used.
            </p>
            <p>
              You may make a purchase from theobxbeachbum.com through a link from another website or search engine. In such event, please be aware that both theobxbeachbum.com and that website or search engine may have access to certain portions of your information. Our Privacy Policy does not apply to those other websites or search engines.
            </p>
          </section>

          <section>
            <h2>Whom Do I Contact with Questions?</h2>
            <p>
              If you have any questions or comments about this Privacy Policy, call us at <strong>1-252-378-8844</strong> or send an email to <a href="mailto:support@theobxbeachbum.com">support@theobxbeachbum.com</a>.
            </p>
          </section>

          <div className="back-link">
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </main>

      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default Privacy;
